import React from 'react';
import moment from 'moment';
import _ from 'lodash';

const AgencyRegistrationApplicationRelationText = ({
  id,
  updatedAt,
  ownId,
  moveDetailPage,
}) => {
  return (
    <div>
      {id === ownId && <span>申請No.{id}</span>}
      {id !== ownId && (
        <span className={'clickable-text'} onClick={() => moveDetailPage(id)}>
          申請No.{id}
        </span>
      )}
      {` 最終更新日時：${moment(updatedAt, 'YYYY/MM/DD HH:mm:ss').format(
        'YYYY/MM/DD HH:mm'
      )}`}
    </div>
  );
};

const createRelationsText = (id, related_applications, moveDetailPage) => {
  if (_.isEmpty(related_applications)) {
    return [];
  }

  return [
    ..._.map(related_applications, (v, index) => (
      <AgencyRegistrationApplicationRelationText
        key={index}
        id={v.agency_registration_application_id}
        updatedAt={v.updated_at}
        ownId={id}
        moveDetailPage={moveDetailPage}
      />
    )),
  ];
};

export default createRelationsText;



// WEBPACK FOOTER //
// ./src/components/AgencyRegistrationApplicationRelationText.jsx